import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-24 md:py-32 bg-warmgray relative overflow-hidden" data-id="element-24">
      <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-25">
        {/* Text Column */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-26">
          <div className="flex items-center gap-4 mb-6" data-id="element-27">
            <div className="h-[1px] w-12 bg-red" data-id="element-28"></div>
            <span className="text-red font-bold tracking-widest uppercase text-sm" data-id="element-29">
              Meet Elizabeth
            </span>
          </div>

          <h2 className="text-4xl md:text-5xl font-serif text-navy mb-8 leading-tight" data-id="element-30">
            From $300 in her pocket to{' '}
            <span className="italic text-sky" data-id="element-31">making history.</span>
          </h2>

          <div className="space-y-6 text-navy/80 text-lg leading-relaxed font-light" data-id="element-32">
            <p data-id="element-33">
              Elizabeth Guzmán is a social worker, union member, and immigrant.
              She came to America from Peru as a young single mother with $300
              in her pocket, working three minimum-wage jobs to afford a
              one-bedroom apartment. She eventually worked her way through
              Northern Virginia Community College, earning two master's degrees.
            </p>
            <p data-id="element-34">
              In 2017, Elizabeth made history as the first Latina immigrant
              elected to the Virginia General Assembly, flipping a
              Republican-held seat by 10 points — and then doing it again in
              2025. She introduced more than 100 bills during her time in office
              and served as vice chair of the education committee.
            </p>
            <p data-id="element-35">
              As a second-generation union member, she led the fight for paid
              sick days and passed historic legislation lifting Virginia's ban
              on public sector collective bargaining. She also expanded Medicaid
              to more than 400,000 Virginians and banned ICE from cooperating
              with local law enforcement.
            </p>
          </div>

          <div className="mt-12 rounded-sm overflow-hidden shadow-2xl" data-id="element-36">
            <img src="https://cdn.magicpatterns.com/uploads/3xZcMwQFmnRZxTkF1qp5Ma/Elizabeth_Guzman-Headshots-51.jpg" alt="Elizabeth Guzmán at home" className="w-full h-auto object-cover" data-id="element-37" />
          </div>

          <div className="mt-10 text-center" data-id="element-38">
            <a href="/about" className="inline-block bg-red hover:bg-red-light text-white font-bold text-sm tracking-widest uppercase px-8 py-4 rounded-sm transition-colors shadow-sm" data-id="element-39">
              Learn More About Elizabeth
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}